module.exports = __webpack_public_path__ + "static/media/logo.a6b2d15c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/logo.png
// module id = 135
// module chunks = 0